module.exports = __webpack_public_path__ + "static/img/fingerpost_refund_10.e7ca98e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_refund_10.jpg
// module id = H5UQ
// module chunks = 0